import JSEncrypt from 'jsencrypt';
 
export default
{ 
    async encryptWithPublicKey(data, publicKeyResponse) {
        const publicKey = publicKeyResponse;

        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(publicKey);
        
        const texto = JSON.stringify(data);
        const encrypted = encryptor.encrypt(texto);
        if (!encrypted) throw new Error("Encryption failed");
        
        return encrypted;
    }
}